module.exports = __webpack_public_path__ + "img/file-minus-01.80570d8d.svg";